import { IS_EA } from '@ben/shared/constants';
import { useMemo } from 'react';
import { useQueryEmployeeSideMenu } from '../queries/use-query-employee-side-menu';
import { useQueryEmployerSideMenu } from '../queries/use-query-employer-side-menu';

export enum EmployerFlagSlug {
  life_events = 'life_events',
  show_only_enrolled_benefits_price = 'show_only_enrolled_benefits_price',
  ea_show_profile = 'ea_show_profile',
  ea_hide_buy_sell_action_controls = 'ea_hide_buy_sell_action_controls',
  ea_hide_expired_opt_out_window = 'ea_hide_expired_opt_out_window',
  mobile_app_available = 'mobile_app_available',
  show_spanish_tax_simulator = 'show_spanish_tax_simulator',
  show_only_henkel_specific_tax_simulator = 'show_only_henkel_specific_tax_simulator',
  use_only_national_tax_band_in_tax_simulator = 'use_only_national_tax_band_in_tax_simulator',
  show_opella_net_pay_simulator = 'show_opella_net_pay_simulator',
}

const useEmployerFlag = (slug: EmployerFlagSlug) => {
  const { data: eaData } = useQueryEmployeeSideMenu({ enabled: IS_EA });
  const { data: eccData } = useQueryEmployerSideMenu({ enabled: !IS_EA });

  return useMemo(() => {
    const values = IS_EA
      ? eaData?.employerConfiguration?.values
      : eccData?.values;

    return values?.find((value) => value.slug === slug)?.value;
  }, [eaData, eccData, slug]);
};

export default useEmployerFlag;
